var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products",style:({
    position:_vm.top>_vm.height?'fixed':'absolute',
    top:_vm.top>_vm.height?'100px':'65px',
}),attrs:{"data-aos":"fade-right"}},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"defaultActive":_vm.defaultActive},on:{"select":_vm.handleSelect}},_vm._l((_vm.productsList),function(item,index){return _c('el-menu-item',{attrs:{"index":item.src,"disabled":index===0
                    || index === 2
                    || index === 3
                    || index === 4
                    || index === 5
                    || index === 6
                    || index === 7
                    || index === 8}},[(index!==0)?_c('span',{domProps:{"innerHTML":_vm._s(item.title)}}):_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(item.title)}}),_c('img',{attrs:{"src":item.src,"alt":"","height":"36px"}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }